import { useMutation } from '@tanstack/react-query';

import { useSupabase } from './use-supabase';

export function useSignOut() {
  const client = useSupabase();

  return useMutation({
    mutationFn: () => {
      localStorage.removeItem('ai-card-open');
      return client.auth.signOut();
    },
  });
}
